import _ from "lodash";
import mixpanel from "mixpanel-browser";
export class MixPanelAdapter {
    constructor() {}

    event(event, fields) {
        let eventName = event
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();
        mixpanel.track(eventName, {
            ...this.params,
            ...fields
        });
    }

    setParamns(params) {
        this.params = params;
    }

    init(token) {
        mixpanel.init(token, { debug: false });
    }

    /**
     * Aviso de cookies: quem recusa sai do rastreamento. O Mixpanel guarda a recusa e bloqueia
     * qualquer `track` depois disso, venha de onde vier.
     */
    optOut() {
        try {
            // Sem `delete_user: false` o SDK apaga o perfil People da pessoa ao recusar.
            mixpanel.opt_out_tracking({ delete_user: false });
        } catch (err) {
            console.warn("Mixpanel opt-out", err);
        }
    }

    optIn() {
        try {
            if (mixpanel.has_opted_out_tracking()) mixpanel.opt_in_tracking();
        } catch (err) {
            console.warn("Mixpanel opt-in", err);
        }
    }

    identify() {
        mixpanel.identify(this.user._id);

        mixpanel.people.set({
            email: _.get(this.user, "username"),
            roles: _.get(this.user, "roles"),
            accountingId: _.get(this.user, "profile.accountingId")
        });
    }

    setUser(user) {
        this.user = user;
        this.identify();
    }
}
